export const LOCAL_STORAGE_PREFIX = '@procureai/';

export enum LocalStorageKeys {
  SEARCH_AI_ENABLED = 'search.ai.enabled',
  SEARCH_AUTOCOMPLETE_RECENT = 'search.autocomplete.recent',
  RESIZE_DRAWER = 'resize.drawer',
}
